import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */

export class TrackingEventsVisibilityProductsMapper extends Mapper {
  constructor({config}) {
    super()

    this._config = config

    this._QUICK_SALE_PRODUCT_ID = this._config.get('seller').QUICK_SALE_PRODUCT_ID
    this._TOP_AD_PRODUCT_ID = this._config.get('seller').TOP_AD_PRODUCT_ID
    this._PACK_VISIBILITY_PRODUCT_ID = this._config.get('seller').PACK_VISIBILITY_PRODUCT_ID

    this._HIT_INFORMATIONS = this._config.get('tracking').HIT_INFORMATIONS
    this._HIT_ORIGINS = this._config.get('tracking').HIT_ORIGINS
    this._TRACKING_EVENT_NAMES = this._config.get('tracking').TRACKING_EVENT_NAMES
  }

  setParams({isDrawerOrigin, productId}) {
    this._isDrawerOrigin = isDrawerOrigin
    this._productId = productId
    return this
  }

  mapVisibilityProductsButtonClicked = event => {
    const data = {}

    if (this._isDrawerOrigin === true || this._isDrawerOrigin === false) {
      const drawerHitInformations = {
        [this._QUICK_SALE_PRODUCT_ID]: this._HIT_INFORMATIONS.VISIBILITY_PRODUCTS_BUY_QUICK_SALE,
        [this._TOP_AD_PRODUCT_ID]: this._HIT_INFORMATIONS.VISIBILITY_PRODUCTS_BUY_TOP,
        [this._PACK_VISIBILITY_PRODUCT_ID]: this._HIT_INFORMATIONS.VISIBILITY_PRODUCTS_BUY_PACK_VISIBILITY
      }

      const drawerHitOrigins = {
        [this._QUICK_SALE_PRODUCT_ID]: this._HIT_ORIGINS.VISIBILITY_PRODUCTS_HOW_QUICK_SALE_WORKS,
        [this._TOP_AD_PRODUCT_ID]: this._HIT_ORIGINS.VISIBILITY_PRODUCTS_HOW_TOP_WORKS,
        [this._PACK_VISIBILITY_PRODUCT_ID]: this._HIT_ORIGINS.VISIBILITY_PRODUCTS_HOW_PACK_VISIBILITY_WORKS
      }

      data.hit_information = drawerHitInformations[this._productId]
      data.hit_origin = this._isDrawerOrigin
        ? drawerHitOrigins[this._productId]
        : this._HIT_ORIGINS.VISIBILITY_PRODUCTS_PAGE
    } else {
      const hitInformations = {
        [this._QUICK_SALE_PRODUCT_ID]: this._HIT_INFORMATIONS.VISIBILITY_PRODUCTS_HOW_QUICK_SALE_WORKS,
        [this._TOP_AD_PRODUCT_ID]: this._HIT_INFORMATIONS.VISIBILITY_PRODUCTS_HOW_TOP_WORKS,
        [this._PACK_VISIBILITY_PRODUCT_ID]: this._HIT_INFORMATIONS.VISIBILITY_PRODUCTS_HOW_PACK_VISIBILITY_WORKS
      }

      data.hit_information = hitInformations[this._productId]
    }

    return {
      event,
      data
    }
  }

  map(eventName) {
    const visibilityProductsMappers = {
      [this._TRACKING_EVENT_NAMES.VISIBILITY_PRODUCTS_BUTTON_CLICKED]: this.mapVisibilityProductsButtonClicked
    }

    return visibilityProductsMappers[eventName] ? visibilityProductsMappers[eventName](eventName) : {event: eventName}
  }
}
